import { z } from "zod";
import { POLICY_TYPES } from "../types/admin-audit.js";

export const recordConsentSchema = z.object({
  policy_type: z.enum(POLICY_TYPES),
  version: z.string().min(1).max(40),
});

export const upsertPolicySchema = z.object({
  version: z.string().min(1).max(40),
  body_markdown: z.string().min(1),
  effective_at: z.string().datetime(),
});

// Guardian consent on behalf of a child (143). Version must match the current
// active child_data policy; the API rejects stale/unknown versions.
export const recordChildConsentSchema = z.object({
  version: z.string().min(1).max(40),
});

export const createCoachNoteSchema = z.object({
  body: z.string().min(1).max(5000),
  visibility: z.enum(["private", "school_coaches"]).optional(),
  tag: z.enum(["performance", "injury", "discipline", "attendance"]).nullable().optional(), // 142
});

export const updateCoachNoteSchema = z.object({
  body: z.string().min(1).max(5000).optional(),
  visibility: z.enum(["private", "school_coaches"]).optional(),
  tag: z.enum(["performance", "injury", "discipline", "attendance"]).nullable().optional(), // 142
});

export type RecordConsentInput = z.infer<typeof recordConsentSchema>;
export type UpsertPolicyInput = z.infer<typeof upsertPolicySchema>;
export type RecordChildConsentInput = z.infer<typeof recordChildConsentSchema>;
export type CreateCoachNoteInput = z.infer<typeof createCoachNoteSchema>;
export type UpdateCoachNoteInput = z.infer<typeof updateCoachNoteSchema>;
